import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiRequest, serializeModel } from "../../../api";
import { CampaignByIdRequest, CampaignRequest } from "./types";
import { BoostingCampaign } from "@vviinn/user-managment-client-ts";
import { compareAsStrings } from "../../../helpers";

export const fetchBoosting = createAsyncThunk(
  "boosting/fetch",
  async ({ api, value }: ApiRequest<CampaignRequest>) => {
    const { companyId, siteId } = value;
    if (companyId === undefined) {
      return [];
    }
    const response = await api.listSiteBoostingCampaigns(companyId, siteId);
    const data = response.value;
    return data.map(serializeModel);
  },
);

export const deleteBoosting = createAsyncThunk(
  "boosting/delete",
  async ({ api, value }: ApiRequest<CampaignByIdRequest>) => {
    const { companyId, siteId, campaignId } = value;
    const response = await api.deleteBoostingCampaign(
      companyId,
      siteId,
      campaignId,
    );
    return response.value;
  },
);

export const upsertBoosting = createAsyncThunk(
  "boosting/upsert",
  async ({
    api,
    value,
  }: ApiRequest<CampaignRequest & { boostingCampaign: BoostingCampaign }>) => {
    const { companyId, siteId, boostingCampaign } = value;
    try {
      const response = await api.upsertSiteBoostingCampaign(
        companyId,
        siteId,
        boostingCampaign,
      );
      return serializeModel(response.value);
    } catch (e) {
      // The client throws ApiException for non-200 responses, including 201 on
      // creation. Only fall back to a list fetch for that specific case.
      if ((e as any)?.code !== 201) throw e;
      const listResponse = await api.listSiteBoostingCampaigns(
        companyId,
        siteId,
      );
      const saved = listResponse.value
        .sort((a, b) => compareAsStrings(b.id, a.id))
        .find((b) => b.name === boostingCampaign.name);
      if (saved) return serializeModel(saved);
      throw new Error("Upsert succeeded but campaign not found in list");
    }
  },
);
